// axios
import axios from 'axios'

// import * as dotenv from 'dotenv'
// const envFound = dotenv.config()
// if (envFound.error) {
//   console.log(envFound.error)
//   throw new Error("⚠️  Couldn't find .env file  ⚠️")
// }

// const baseURL = 'http://localhost:4000/api'
const baseURL = 'https://insights-api.yemaachi.com/api'

export default axios.create({
  baseURL
  // You can add your headers here
})
